import { api } from "@/api";
import useErrorHandling from "@/hooks/useErrorHandling";
import { Button, Input } from "@heroui/react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

interface PasswordRecoveryPromptForm {
  login: string;
}

export function NewResetPage() {
  const navigate = useNavigate();
  const handleError = useErrorHandling();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PasswordRecoveryPromptForm>({
    defaultValues: {},
  });

  const resetPassword = (data: any) => {
    api.auth
      .requestReset({ username: data.login })
      .then((_data) => {
        toast.success("Код для восстановления успешно отправлен!");
        navigate("/auth/reset/" + data.login);
      })
      .catch((err) => {
        console.log(err);
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });
  };

  return (
    <>
      <div className="w-screen h-dvh min-h-dvh flex flex-col items-center justify-center">
        <div className="w-screen max-w-lg max-lg:max-w-screen-lg flex flex-col p-4 items-center">
          <div className="mb-2">
            <img src="/logo.svg" width={"128"}></img>
          </div>
          <div className="mb-2">
            <span className="font-medium text-xl">Сброс пароля</span>
          </div>
          <div className="mb-4">
            <span>
              Если к имени пользователя, указанному Вами, была привязана
              электронная почта, мы отправим Вам письмо с кодом для
              восстановления аккаунта.
            </span>
          </div>
          <div className="flex flex-col gap-2 justify-self-end h-full w-full">
            <form
              className="flex flex-col gap-2 h-full"
              onSubmit={handleSubmit(resetPassword)}
            >
              <Input
                label="Имя пользователя"
                placeholder="Введите логин"
                variant="bordered"
                type="text"
                {...register("login", { required: true })}
                className="mb-2"
                isInvalid={!!errors["login"]}
                errorMessage={errors["login"]?.message?.toString()}
              />
              <Button
                color="primary"
                className="w-full font-semibold"
                type="submit"
              >
                Восстановить
              </Button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
